// src/components/dashboard/MetricsGrid.jsx
import React from "react";
import { CheckCircle2, AlertTriangle, Target, TrendingUp } from "lucide-react";
import { Skeleton } from "components/ui/skeleton";

export default function MetricsGrid({ metrics = {}, isLoading }) {
  const safe = (n, d = 0) => (typeof n === "number" ? n : d);

  const metricCards = [
    {
      title: "Validated Problems",
      value: safe(metrics.validatedProblems, 0),
      total: typeof metrics.totalProblems === "number" ? metrics.totalProblems : null,
      icon: CheckCircle2,
      color: "emerald",
      trend: "Based on saved problems",
    },
    {
      title: "Critical Issues",
      value: safe(metrics.criticalIssues, 0),
      total: null,
      icon: AlertTriangle,
      color: "red",
      trend: safe(metrics.criticalIssues, 0) > 5 ? "Needs attention" : "Under control",
    },
    {
      title: "Active Experiments",
      value: safe(metrics.activeHypotheses, 0),
      total: null,
      icon: Target,
      color: "blue",
      trend: "Testing hypotheses",
    },
    {
      title: "Avg Confidence",
      value: typeof metrics.avgConfidence === "number" ? `${metrics.avgConfidence}%` : "0%",
      total: null,
      icon: TrendingUp,
      color: "purple",
      trend:
        typeof metrics.avgConfidence === "number" && metrics.avgConfidence > 70
          ? "High confidence"
          : "Building confidence",
    },
  ];

  return (
    <div className="stat-grid">
      {metricCards.map((metric, index) => {
        const Icon = metric.icon;
        return (
          <div className="stat" key={index}>
            <span className="stat-label"><Icon aria-hidden="true" />{metric.title}</span>
            {isLoading ? (
              <Skeleton style={{ height: 26, width: 64 }} />
            ) : (
              <span className="stat-value">
                {metric.value}
                {metric.total != null && <span style={{ fontSize: 14, color: "var(--fg-subtle)", fontWeight: 500 }}> / {metric.total}</span>}
              </span>
            )}
            {!isLoading && metric.trend && <span className="stat-hint">{metric.trend}</span>}
          </div>
        );
      })}
    </div>
  );
}
